import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import user from '@/lib/vuex-modules/user';
import breadcrumbs from "@/lib/vuex-modules/breadcrumbs";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

let clientUrl = process.env.VUE_APP_CLIENT_URL;
// let clientUrl = 'http://localhost:8080';
let siteUrl = process.env.VUE_APP_API_URL;
// let siteUrl = 'http://localhost:8000';
// let siteUrl = 'http://192.168.2.50:8000';


export default new Vuex.Store({
  modules: {
    user: user,
    breadCrumbs: breadcrumbs,
  },
  state: {
    currentCardset: null,
    currentStack: null,
    endpoints: {
      obtainJWT: siteUrl + '/token/obtain/',
      refreshJWT: siteUrl + '/token/refresh/',
      // socialAuth: '/auth/social/jwt-sliding-user/',
      logout: siteUrl + '/logout',
      // socialAuth: '/complete/google-oauth2/',
      userInfo: siteUrl + '/user-info/',
      loginGoogle: siteUrl + '/social/login/google-oauth2/',
      completeGoogle: siteUrl + '/social/complete/google-oauth2',
      loginFacebook: siteUrl + '/social/login/facebook/',
      completeFacebook: siteUrl + '/social/complete/facebook/',
    },
    bottomNav: {
      frontShowing: false,
      backShowing: false,
    },
    authRedirectUri: clientUrl + '/#/auth/callback',
    apiBaseUrl: siteUrl,
    siteUrl: siteUrl,
    cardsets: {},
  },
  getters: {
    currentCardset (state) {
      return state.currentCardset;
    },
    // eslint-disable-next-line no-unused-vars
    getCardset (state, getters) {
      return function (pk) {
        // if (getters.hasCardset(state)) {
          return state.cardsets[pk];
        // }
        // return null;
      }
    },
    hasCardset (state) {
      return function (pk) {
        return Object.prototype.hasOwnProperty.call(state.cardsets, pk);
      }
    }
  },
  mutations: {
    navShowFront (state) {
      state.bottomNav.frontShowing = true;
      state.bottomNav.backShowing = false;
    },
    navShowBack (state) {
      state.bottomNav.frontShowing = false;
      state.bottomNav.backShowing = true;
    },
    navShowCardset (state) {
      state.bottomNav.frontShowing = false;
      state.bottomNav.backShowing = true;
    },
    setCurrentStack (state, stack) {
      state.currentStack = stack;
    },
    clearCurrentStack (state) {
      state.currentStack = null;
    },
    setCurrentCardset (state, stack) {
      state.currentCardset = stack;
    },
    clearCurrentCardset (state) {
      state.currentCardset = null;
    },
    storeCardset (state, cardset) {
      state.cardsets[cardset.id] = cardset;
    }
  },
  actions: {
  }
})
